<template>
	<div>
		<CRow>
			<CCol sm="12">
				<CCard>
					<CCardHeader>
						Gestion des clients

						<div class="card-header-actions">
							<CButton color="primary" v-on:click="showUserAddModal()"> + Ajouter </CButton>
						</div>
					</CCardHeader>

					<CCardBody>
						<GDataTableRemote
							ref="mainTable"
							remote-url="/api/users?role[]=ROLE_CUSTOMER&role[]=ROLE_GUEST"
							:fields="fields"
							:items-per-page="10"
							hover
							striped
							sorter
							columnFilter
							pagination>
							<template #actions="{ item }">
								<td class="text-center">
									<router-link :to="`/clients/${item.id}/edit`">
										<CIcon name="cil-pencil" />
									</router-link>
								</td>
							</template>
						</GDataTableRemote>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>

		<AjouterModal ref="AjouterModal" v-on:refresh="refresh()" />
	</div>
</template>
<script>
	import GDataTableRemote from '../../../components/ghostlexly-components/GDataTableRemote';
	import AjouterModal from './ClientAjouter';

	export default {
		components: {
			GDataTableRemote,
			AjouterModal,
		},

		data() {
			return {
				fields: [
					{ key: 'id', _classes: 'font-weight-bold' },
					{ key: 'userCode', label: 'Code' },
					{ key: 'email' },
					{ key: 'createdAt', label: 'Date de création', type: 'datetime' },
					{ key: 'actions', filter: false },
				],
				activePage: 1,
			};
		},

		methods: {
			showUserAddModal: function () {
				this.$refs.AjouterModal.showModal = true;
			},
			showUserEditModal: function ($user) {
				this.$refs.ModifierModal.user = $user;
				this.$refs.ModifierModal.showModal = true;
			},
			refresh: function () {
				this.$refs.mainTable.refresh();
			},
		},
	};
</script>
